/**
 * Simple ID generator utility
 * Generates unique IDs for the application
 */

export const generateId = () => {
  // Generate a random string with timestamp and random characters
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substr(2, 9);
  return `${timestamp}_${randomPart}`;
};

export const generateShortId = () => {
  // Generate a shorter ID (8 characters)
  return Math.random().toString(36).substr(2, 8);
};

export const generateNumericId = () => {
  // Generate a numeric ID based on timestamp + random number
  return Date.now() + Math.floor(Math.random() * 1000);
};

export const generateUUID = () => {
  // Simple UUID v4 generator (not cryptographically secure)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export default generateId;

